export { default } from '../src/page-home';
